<div class="edit-digital-twin-container">
  <div class="header-container">
    <h2 mat-dialog-title>Edit Vehicle</h2>
    <button mat-icon-button class="close-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <hr class="header-divider">
  
  <div mat-dialog-content class="dialog-content">
    <div class="search-container">
      <div class="select-all-wrapper" *ngIf="displayedVehicles.length > 0">
        <mat-checkbox [checked]="selectAll" [indeterminate]="someSelected && !selectAll" (change)="onSelectAllChange($event)">
          Select All Vehicles (Across All Pages)
        </mat-checkbox>
      </div>
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search Vehicle</mat-label>
        <input matInput type="text" [(ngModel)]="searchQuery" name="searchQuery" (ngModelChange)="onSearchChange()">
        <button *ngIf="searchQuery" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>
    
    <form [formGroup]="vehicleForm" name="vehicleForm">
      <div class="vehicle-list">
        <ng-container *ngFor="let vehicle of displayedVehicles; let i = index">
          <div class="vehicle-item">
            <div class="vehicle-selection">
              <mat-checkbox [checked]="vehicle.isSelected" (change)="onVehicleSelect(i, $event)"></mat-checkbox>
            </div>
            <div class="vehicle-details">
              <div class="vehicle-info">
                <div class="vehicle-number">
                  <img src="assets/icons/vehicle-icon.svg" alt="Vehicle" class="vehicle-icon">
                  <div class="vehicle-id">{{vehicle.vehicleNumber}}</div>
                </div>
              </div>
              <div class="vehicle-specs">
                <div class="spec-group">
                  <div class="spec-label">Maximum Capacity</div>
                  <div class="spec-value">{{vehicle.maxLoadVolume.toFixed(3)}} CBM</div>
                </div>
                <div class="spec-group">
                  <div class="spec-label">Maximum Weight</div>
                  <div class="spec-value">{{vehicle.maxLoadWeight}} Kg</div>
                </div>
                <div class="spec-group">
                  <div class="spec-label">Status</div>
                  <div class="spec-value">
                    <ng-container *ngIf="isStatusLoading; else statusValue">
                      <div class="loading-status">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Loading...</span>
                      </div>
                    </ng-container>
                    <ng-template #statusValue>
                      {{vehicle.status}}
                    </ng-template>
                  </div>
                </div>
                <div class="spec-group capacity-group">
                  <div class="spec-label">Vehicle Capacity Utilization</div>
                  <div class="utilization-controls">
                    <div class="slider-row">
                      <input 
                        type="range"
                        min="0"
                        max="100"
                        step="1"
                        [value]="vehicle.capacityUtilization ?? 100"
                        (input)="updateCapacityUtilization(i, $event, 'slider')"
                        [style.background]="'linear-gradient(to right, #6361DA 0%, #6361DA ' + (vehicle.capacityUtilization ?? 100) + '%, #E0E0E0 ' + (vehicle.capacityUtilization ?? 100) + '%, #E0E0E0 100%)'"
                        class="utilization-slider html-range-slider">
                      <div class="utilization-input-container">
                        <input type="number" min="0" max="100" 
                              [value]="vehicle.capacityUtilization ?? 100" 
                              (change)="updateCapacityUtilization(i, $event, 'input')"
                              class="number-input">
                        <span class="percent-symbol">%</span>
                      </div>
                    </div>
                    <div class="slider-labels">
                      <span>0%</span>
                      <span>100%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <mat-divider *ngIf="i < displayedVehicles.length - 1"></mat-divider>
        </ng-container>

        <div *ngIf="displayedVehicles.length === 0" class="no-vehicles">
          No vehicles found matching your search
        </div>
      </div>
    </form>

    <div class="pagination-container">
      <div class="items-per-page">
        <span>Items per page</span>
        <div class="select-wrapper">
          <span class="selected-size">{{ pageSize }}</span>
          <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
          <mat-select [(value)]="pageSize" (selectionChange)="onPageSizeChange($event)" class="hidden-select">
            <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</mat-option>
          </mat-select>
        </div>
      </div>
      <div class="custom-pagination">
        <button mat-icon-button (click)="previousPage()" [disabled]="pageIndex === 0">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <ng-container *ngFor="let page of getPagesArray(); let i = index">
          <button mat-button 
                 [class.active-page]="pageIndex === page - 1"
                 (click)="goToPage(page - 1)">
            {{ page }}
          </button>
        </ng-container>
        <button mat-icon-button (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button color="secondary" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()">Update</button>
  </div>
</div> 